"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
// (C) 2007-2021 GoodData Corporation
var helpers_1 = require("../../../chartTypes/_chartCreators/helpers");
var dataLabelsHelpers_1 = require("../../../chartTypes/_chartCreators/dataLabelsHelpers");
var sdk_ui_1 = require("@gooddata/sdk-ui");
var autohideColumnLabels_1 = require("./autohideColumnLabels");
var autohideBarLabels_1 = require("./autohideBarLabels");
var autohidePieLabels_1 = tslib_1.__importDefault(require("./autohidePieLabels"));
var autohideLabelsOverlappingItsShape_1 = tslib_1.__importDefault(require("./autohideLabelsOverlappingItsShape"));
// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
var autohideLabels = function (Highcharts) {
    Highcharts.wrap(Highcharts.Chart.prototype, "hideOverlappingLabels", function (proceed, labels) {
        // eslint-disable-next-line @typescript-eslint/no-this-alias
        var chart = this;
        var chartType = helpers_1.getChartType(this);
        var dataLabelsUserVisibility = dataLabelsHelpers_1.getDataLabelsGdcVisible(this);
        if (dataLabelsUserVisibility === "auto") {
            switch (chartType) {
                case sdk_ui_1.VisualizationTypes.COLUMN:
                    autohideColumnLabels_1.autohideColumnLabels(chart);
                    return;
                case sdk_ui_1.VisualizationTypes.BAR:
                    autohideBarLabels_1.autohideBarLabels(chart);
                    return;
                case sdk_ui_1.VisualizationTypes.PIE:
                case sdk_ui_1.VisualizationTypes.DONUT:
                    autohidePieLabels_1.default(chart);
                    return;
                case sdk_ui_1.VisualizationTypes.TREEMAP:
                case sdk_ui_1.VisualizationTypes.HEATMAP:
                    autohideLabelsOverlappingItsShape_1.default(chart);
                    return;
                case sdk_ui_1.VisualizationTypes.BUBBLE:
                    autohideLabelsOverlappingItsShape_1.default(chart, function (point) {
                        // only hide is not enough for combination with default label collision detection
                        dataLabelsHelpers_1.minimizeDataLabel(point);
                        dataLabelsHelpers_1.hideDataLabel(point);
                    });
                    proceed.call(this, labels);
                    return;
            }
        }
        else if (dataLabelsUserVisibility === true) {
            switch (chartType) {
                case sdk_ui_1.VisualizationTypes.COLUMN:
                    autohideColumnLabels_1.handleColumnLabelsOutsideChart(chart);
                    return;
                case sdk_ui_1.VisualizationTypes.BAR:
                    autohideBarLabels_1.handleBarLabelsOutsideChart(chart);
                    return;
            }
        }
        proceed.call(this, labels);
    });
};
exports.default = autohideLabels;
//# sourceMappingURL=autohideLabels.js.map